import React from 'react';

// import components
import Accordion, { AccordionItem } from 'components/partials/accordion';
import { PrimaryButtonProps } from "components/partials/buttons/primary-button";

// import helpers
import { getLinkDataFromDato } from "helpers/get-link-data";

const AccordionBuilder: React.FC<{ accordionData?: Queries.AccordionBlockFragment }> = ({ accordionData }) => {
    if (!accordionData) return null;

    const openFirst = accordionData.autoExpandFirstItemOnPageLoad || false;

    const accordionItems = accordionData?.items?.map((item, index): AccordionItem | undefined => {

        const linkData = getLinkDataFromDato(item?.link?.link);

        const button: PrimaryButtonProps | undefined = linkData ? {
            buttonText: linkData.label || 'Error: Missing Button Text',
            buttonUrl: linkData.url || "#",
            target: linkData.target || "_self",
            plain: true
        } : undefined;

        const sponsorsCarouselData = item?.sponsors && item?.sponsors.length > 0 && {
            __typename: 'DatoCmsSponsorsCarousel',
            id: 'accordion-item-sponsor-carousel',
            heading: item?.sponsorHeading || "Sponsors",
            sponsors: item?.sponsors || []
        } as Queries.SponsorsCarouselBlockFragment || undefined;

        return {
            headline: item?.heading || '',
            content: typeof item?.content === 'object' && item?.content !== null ? item?.content.content || '' : '',
            isOpen: openFirst && index === 0,
            buttonLink: button,
            sponsorsCarouselData: sponsorsCarouselData
        };

    }).filter((item): item is AccordionItem => item !== undefined) || [];

    return (
        <Accordion
            id={accordionData.id || undefined}
            headline={accordionData.heading || ''}
            items={accordionItems}
        />
    );
};

export default AccordionBuilder;